/**
 * Created by pandemio on 9/20/18.
 */
class SessionManager {
    /**
     * Sets the session
     * @param token
     */
    static setSession(token)
    {
        localStorage.setItem('ul', token);
    }

    /**
     * Sets the session for the employee
     * @param token
     */
    static setSessionEmployee(token)
    {
        localStorage.setItem('el', token);
    }

    /**
     * Returns the session
     * @returns {*}
     */
    static getSession(){
        let session = null;
        if(localStorage.getItem('ul') != null)
            session = localStorage.getItem('ul');
        return session;
    }

    /**
     * Returns the session of the employee
     * @returns {*}
     */
    static getSessionEmployee(){
        let session = null;
        if(localStorage.getItem('el') != null)
            session = localStorage.getItem('el');
        return session;
    }

    /**
     * Evaluates if session is active or not
     * @returns {boolean}
     */
    static evaluateSession(){
        return (SessionManager.getSession() != null && SessionManager.getSession().length > 0);
    }

    /**
     * Evaluates if the session of the employee is active
     * @returns {boolean}
     */
    static evaluateSessionEmployee(){
        return (SessionManager.getSessionEmployee() != null && SessionManager.getSessionEmployee().length > 0);
    }

    /**
     * Deletes a session
     */
    static deleteSession(){
        return localStorage.removeItem('ul');
    }

    /**
     * Deletes a session
     */
    static deleteSessionEmployee(){
        return localStorage.removeItem('el');
    }
}

export default SessionManager;
